/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneTipoCreateDTO
 */
export interface DeambulazioneTipoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneTipoCreateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneTipoCreateDTO interface.
 */
export function instanceOfDeambulazioneTipoCreateDTO(value: object): value is DeambulazioneTipoCreateDTO {
    return true;
}

export function DeambulazioneTipoCreateDTOFromJSON(json: any): DeambulazioneTipoCreateDTO {
    return DeambulazioneTipoCreateDTOFromJSONTyped(json, false);
}

export function DeambulazioneTipoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneTipoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneTipoCreateDTOToJSON(value?: DeambulazioneTipoCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

